<fa-icon [icon]="icon" class="icon" *ngIf="icon" [classes]="faClasses"></fa-icon> <span class="text">{{ value }}</span>
